import React from 'react';
import styled from "styled-components";
import {deviceMax} from "../../../styles/device";
import {MDXRemote} from "next-mdx-remote";
import AdvertisementComponents from "../../constants/AdvertisementComponents";
import MobileKayitForm from "../mobileKayitForm/MobileKayitForm";
import LandingSubHeroArea from "../landing/LandingSubHeroArea";
import WaveLayout from "../../layouts/WaweLayout";

type IProps = {
    source: any
    frontMatter: any
}

const AdvertisementLayoutMobileComp = (props: IProps) => {
    return (
        <React.Fragment>
            <WaveLayout backgroundColor={'unset'}
                        hamburgerMenuType={'black'} hamburgerMenu={false} loginButtonMenu={true} registerButton={false} waveComponent={false} bgColor={true}
                        extraChildren={
                            <React.Fragment>
                                <MDXRemote {...props.source} components={AdvertisementComponents}/>
                            </React.Fragment>
                        }
            >
                <React.Fragment>
                    <KayitWrapper>
                        <MobileKayitForm/>
                    </KayitWrapper>
                    <LandingSubHeroArea frontMatter={props.frontMatter}/>
                </React.Fragment>
            </WaveLayout>
        </React.Fragment>
    );
};



const KayitWrapper = styled.div`
    position: relative;
    background: #0000000D;
    width: calc(100% + 48px);
    margin-left: -24px;
    
  @media ${deviceMax.tablet} {
      padding: 0 24px 20px;
      margin-bottom: 20px;
  }
`;

export default AdvertisementLayoutMobileComp;
